import styled from "styled-components";

export const Text = styled.span`
  font-weight: 500;
  font-size: 1.25;
  color: var(--neutral);
`;

export const OrganizationalLink = styled.a`
  text-decoration: none;
  display: block;
  border-radius: 4px;
  padding: 8px 16px;
  &:hover {
    background-color: var(--gray-light);
  }
`;

export const TierLabel = styled.h3`
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--neutral);
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 20px;
    background: linear-gradient(180deg, var(--primary) 0%, var(--primary-light) 100%);
    border-radius: 2px;
  }
`;

export const TierBlock = styled.div`
  margin-bottom: 48px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ResponsibleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
`;

export const ResponsibleCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  text-decoration: none;
  padding: 24px 16px;
  border-radius: 10px;
  border: 1px solid var(--gray-light);
  background: white;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
`;

export const ResponsiblePhoto = styled.img`
  width: 88px;
  height: 88px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 14px;
  background: var(--gray-lightest);
`;

export const ResponsiblePhotoPlaceholder = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin-bottom: 14px;
  background: var(--gray-lightest);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--primary);
`;

export const ResponsibleName = styled.span`
  font-weight: 700;
  font-size: 0.9375rem;
  color: var(--neutral);
`;

export const ResponsibleRole = styled.span`
  font-size: 0.8125rem;
  color: var(--neutral-light);
  margin-top: 2px;
`;

export const DepartmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DepartmentCard = styled.div`
  border: 1px solid var(--gray-light);
  border-radius: 8px;
  background: white;
  overflow: hidden;
`;

export const DepartmentHeader = styled.button`
  all: unset;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  cursor: pointer;
  background-color: var(--gray-lightest);

  &:hover {
    background-color: rgba(37, 99, 235, 0.06);
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: -2px;
  }
`;

export const DepartmentName = styled.span`
  font-weight: 600;
  font-size: 1rem;
  color: var(--neutral);
`;

export const ToggleIcon = styled.img<{ $expanded: boolean }>`
  width: 14px;
  height: 14px;
  transition: transform 0.2s ease;
  transform: rotate(${(props) => (props.$expanded ? "180deg" : "0deg")});
  flex-shrink: 0;
`;

export const DepartmentDetails = styled.div`
  padding: 18px 20px 20px 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const DetailLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--neutral-light);
`;

export const DetailValue = styled.span`
  font-size: 0.9375rem;
  color: var(--neutral);
`;

export const MoreInfoLink = styled.a`
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--primary);
  text-decoration: none;
  align-self: start;
  margin-top: 4px;

  &:hover {
    text-decoration: underline;
  }
`;
